import { render } from "./opTableLocal.vue?vue&type=template&id=7b165e1e&ts=true"
import script from "./opTableLocal.vue?vue&type=script&lang=ts"
export * from "./opTableLocal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__